export default __webpack_public_path__ + "static/media/ec.79b6a040.svg";